import { createTheme } from "@mui/material/styles";

/**
 * MUI theme with extended breakpoints for app layouts.
 * Uses built-in xs, sm, md, lg, xl plus custom values for layouts.
 */
export const muiTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      tablet: 768,
      tabletUp: 769,
      desktop: 1024,
      desktopUp: 1025,
      desktopMd: 1100,
      desktopLg: 1280,
      mobile: 720,
      mobileXs: 400,
      desktopSm: 960,
    },
  },
});
